(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kq-spirits-shop"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kq-spirits-shop')) {
    customElements.define('kq-spirits-shop', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.cards = [...this.querySelectorAll('[data-kq-card]')];
        this.results = this.querySelector('[data-kq-results]');
        this.status = this.querySelector('[data-kq-count]');
        this.empty = this.querySelector('[data-kq-empty]');
        this.reset = this.querySelector('[data-kq-reset]');
        this.fields = Object.fromEntries(['brand','type','group','sort'].map(key => [key, this.querySelector(`[data-kq-${key}]`)]));
        this.querySelector('[data-kq-controls]').hidden = false;
        this.querySelector('[data-kq-controls]').addEventListener('change', () => this.update(true));
        this.reset.addEventListener('click', () => { Object.values(this.fields).forEach(field => field.value = ''); this.update(true); });
        const params = new URL(window.location.href).searchParams;
        Object.entries(this.fields).forEach(([key,field]) => { const value = params.get(`kq_${key}`) || ''; if ([...field.options].some(option => option.value === value)) field.value = value; });
        this.update(false);
      }
      update(writeUrl) {
        const values = Object.fromEntries(Object.entries(this.fields).map(([key,field]) => [key,field.value]));
        const cards = this.cards.filter(card => (!values.brand || card.dataset.brand === values.brand) && (!values.type || card.dataset.type === values.type));
        if (values.sort === 'price-asc') cards.sort((a,b) => Number(a.dataset.price) - Number(b.dataset.price));
        if (values.sort === 'price-desc') cards.sort((a,b) => Number(b.dataset.price) - Number(a.dataset.price));
        if (values.sort === 'title') cards.sort((a,b) => a.dataset.title.localeCompare(b.dataset.title));
        const groups = new Map();
        cards.forEach(card => { const group = values.group ? card.dataset[values.group] : ''; if (!groups.has(group)) groups.set(group,[]); groups.get(group).push(card); });
        const fragment = document.createDocumentFragment();
        const keys = [...groups.keys()];
        if (values.group) keys.sort((a,b) => a.localeCompare(b));
        keys.forEach(key => {
          const list = document.createElement('ul'); list.className = 'kq-shop__grid'; list.setAttribute('role','list');
          groups.get(key).forEach(card => list.append(card));
          if (values.group) { const group = document.createElement('section'); group.className = 'kq-shop__group'; const heading = document.createElement('h2'); heading.textContent = key; group.append(heading,list); fragment.append(group); }
          else fragment.append(list);
        });
        this.results.replaceChildren(fragment);
        this.status.textContent = cards.length === 1 ? this.status.dataset.one : this.status.dataset.many.replace('COUNT', String(cards.length));
        this.empty.hidden = cards.length > 0;
        this.reset.hidden = !Object.values(values).some(Boolean);
        if (writeUrl) { const url = new URL(window.location.href); Object.entries(values).forEach(([key,value]) => value ? url.searchParams.set(`kq_${key}`,value) : url.searchParams.delete(`kq_${key}`)); window.history.replaceState(null,'',url); }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
